import { useEffect, useState } from 'react';
import { parseJSON, intervalToDuration, differenceInMilliseconds } from 'date-fns';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import './Countdown.css';

const CountdownCell = (props: GridCustomCellProps) => {
  const [, setTime] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => setTime(Date.now()), 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  if (!props.field || props.rowType !== 'data') return null;
  if (!props.dataItem[props.field]) return <td {...props.tdProps} />;

  const msDuration = differenceInMilliseconds(parseJSON(props.dataItem[props.field]), new Date());
  if (msDuration <= 0) {
    return <td {...props.tdProps} className={[props.tdProps?.className, "countdown-critical"].filter(Boolean).join(" ")}>Expired</td>
  }
  const duration = intervalToDuration({ start: 0, end: msDuration })

  if (duration.days && duration.days > 1) {
    const formattedDuration = `${duration.days}d ${duration.hours || 0}h ${duration.minutes || 0}m ${duration.seconds || 0}s`;
    return <td {...props.tdProps}>{formattedDuration}</td>;
  }

  if (duration.hours && duration.hours > 1) {
    const formattedDuration = `${duration.hours}h ${duration.minutes || 0}m ${duration.seconds || 0}s`;
    return <td {...props.tdProps}>{formattedDuration}</td>;
  }

  const formattedDuration = `${duration.minutes || 0}m ${duration.seconds || 0}s`;
  if (msDuration > 1000 * 60 * 10) {
    return <td {...props.tdProps}>{formattedDuration}</td>;
  }

  if (msDuration > 1000 * 60 * 5) {
    return <td {...props.tdProps} className={[props.tdProps?.className, "countdown-warning"].filter(Boolean).join(" ")}>{formattedDuration}</td>;
  }

  return <td {...props.tdProps} className={[props.tdProps?.className, "countdown-critical"].filter(Boolean).join(" ")}>{formattedDuration}</td>;
}

export default CountdownCell;
